import useCommonApi from "../api/useCommonApi";

export const GUIA_PDF_IMPRESION_PRIMERA = 0;

export const GUIA_PDF_IMPRESION_REIMPRESION = 1;

const useGuiaPdf = () => {
    const api = useCommonApi();

    const obtenerPdfBase64 = async (guiaId: number, impresion: number): Promise<string> => {
        if (!guiaId || guiaId <= 0) {
            throw new Error("GuiaId inválido.");
        }
        return await api.postAsync<string>(`guia/guia-pdf/${guiaId}?impresion=${impresion}`);
    };

    return { obtenerPdfBase64 };
};

export default useGuiaPdf;
